module.exports = __webpack_public_path__ + "static/media/landing-page-menu-close.ae94b911.svg";